import { useState } from "react";
import { useParams } from "react-router-dom";
import { Notification } from "src/utils/Notification";

import { useConvertLbEntry } from "../../../../../../generator/hooks/useConvertLbEntry";
import { usePostApi } from "../../../../../../hooks";
import { Button } from "../../../../../shared/Button/Button";

interface Props {
  refetch: () => Promise<void>;
}
const SaveUsersMedicalStatement = ({ refetch }: Props) => {
  const { userid } = useParams();

  const convert = useConvertLbEntry();
  const { post } = usePostApi();
  const [loading, setLoading] = useState(false);
  const handleSave = async () => {
    setLoading(true);
    await post({
      request: "save-med-card-statement",
      body: {
        params: {
          userid,
          card: JSON.parse(convert()),
        },
      },
    });
    await refetch();
    Notification("Success", "Medical statement saved successfully", "green");
    setLoading(false);
  };
  return (
    <Button
      variant="outline"
      onClick={handleSave}
      loading={loading}
      style={{ borderWidth: 2 }}>
      <span style={{ fontWeight: 200 }}>Save</span>
    </Button>
  );
};
export default SaveUsersMedicalStatement;
